const transitions = {
  regular: {
    duration: '0.4s',
    ease: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
  },
};

export default transitions;
